import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#1a1a2e] px-8 lg:px-16 py-12 lg:py-16 relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute bottom-0 left-0 right-0 text-[#252540] font-black text-[80px] lg:text-[120px] opacity-30 text-center leading-none pb-4" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
        OKAYAMA
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
        {/* Column 1: Company Info */}
        <div>
          <h3 className="text-white text-lg font-bold mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            株式会社おかやま工務店
          </h3>
          <div className="flex flex-col space-y-3">
            <p className="text-gray-400 text-sm leading-relaxed">
              〒700-0000 岡山市北区○○町1-2-3
            </p>
            <a href="tel:086-012-3456" className="text-gray-400 text-sm hover:text-white transition-colors whitespace-nowrap">
              <strong className="text-white">TEL:</strong> 086-012-3456
            </a>
            <p className="text-gray-400 text-sm whitespace-nowrap">
              <strong className="text-white">FAX:</strong> 086-012-3457
            </p>
            <p className="text-gray-400 text-sm">
              <strong className="text-white">営業時間:</strong> 8:00 〜 17:00
            </p>
            <p className="text-gray-400 text-sm">
              <strong className="text-white">定休日:</strong> 日曜日・祝日
            </p>
          </div>
        </div>

        {/* Column 2: Site Map */}
        <div>
          <h4 className="text-white text-base font-semibold mb-4">サイトマップ</h4>
          <nav className="flex flex-col space-y-3">
            <a
              href="/#hero-section"
              onClick={(e) => {
                e.preventDefault();
                const isHome = window.location.pathname === '/' || window.location.pathname.endsWith('/');
                if (isHome) {
                  const el = document.getElementById('hero-section');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                } else {
                  window.REACT_APP_NAVIGATE('/');
                  setTimeout(() => {
                    const el = document.getElementById('hero-section');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }, 300);
                }
              }}
              className="text-gray-400 text-sm hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              TOP
            </a>
            <a
              href="/#services"
              onClick={(e) => {
                e.preventDefault();
                const isHome = window.location.pathname === '/' || window.location.pathname.endsWith('/');
                if (isHome) {
                  const el = document.getElementById('services');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                } else {
                  window.REACT_APP_NAVIGATE('/');
                  setTimeout(() => {
                    const el = document.getElementById('services');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }, 300);
                }
              }}
              className="text-gray-400 text-sm hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              サービス内容
            </a>
            <a
              href="/#company-section"
              onClick={(e) => {
                e.preventDefault();
                const isHome = window.location.pathname === '/' || window.location.pathname.endsWith('/');
                if (isHome) {
                  const el = document.getElementById('company-section');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                } else {
                  window.REACT_APP_NAVIGATE('/');
                  setTimeout(() => {
                    const el = document.getElementById('company-section');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }, 300);
                }
              }}
              className="text-gray-400 text-sm hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              会社概要
            </a>
            <a
              href="/#faq-section"
              onClick={(e) => {
                e.preventDefault();
                const isHome = window.location.pathname === '/' || window.location.pathname.endsWith('/');
                if (isHome) {
                  const el = document.getElementById('faq-section');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                } else {
                  window.REACT_APP_NAVIGATE('/');
                  setTimeout(() => {
                    const el = document.getElementById('faq-section');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }, 300);
                }
              }}
              className="text-gray-400 text-sm hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              よくある質問
            </a>
            <a
              href="/#contact-section"
              onClick={(e) => {
                e.preventDefault();
                const isHome = window.location.pathname === '/' || window.location.pathname.endsWith('/');
                if (isHome) {
                  const el = document.getElementById('contact-section');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                } else {
                  window.REACT_APP_NAVIGATE('/');
                  setTimeout(() => {
                    const el = document.getElementById('contact-section');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }, 300);
                }
              }}
              className="text-gray-400 text-sm hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
            </a>
          </nav>
        </div>

        {/* Column 3: Service Area */}
        <div>
          <h4 className="text-white text-base font-semibold mb-4">対応地域</h4>
          <ul className="flex flex-col space-y-3">
            <li className="text-gray-400 text-sm">岡山市北区</li>
            <li className="text-gray-400 text-sm">岡山市中区</li>
            <li className="text-gray-400 text-sm">岡山市南区</li>
            <li className="text-gray-400 text-sm">岡山市東区</li>
            <li className="text-gray-400 text-sm">倉敷市</li>
            <li className="text-gray-400 text-sm">その他近隣市町村</li>
          </ul>
        </div>
      </div>

      {/* Copyright */}
      <div className="relative z-10 max-w-[1400px] mx-auto mt-12 pt-8 border-t border-gray-700 text-center">
        <p className="text-gray-500 text-xs">
          © 2025 株式会社おかやま工務店 All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
